import { LAB_SAL_SALARIES_ITEM } from './lab-sal-salaries.js'
import { LAB_SAL_PERIODS_ITEM } from './lab-sal-periods.js'
import { LAB_SAL_PAYMENTS_ITEM } from './lab-sal-payments.js'

/** @type {import('../help-index.js').HelpScreen} */
export const LAB_SAL_HELP = {
  screenId: 'lab-sal',
  label: 'Salarios',
  navPath: 'Laboral → Salarios',
  keywords: [
    'salario', 'sueldo', 'periodo', 'liquidación', 'pago empleado', 'nómina', 'quincena', 'sac',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Períodos de liquidación, importes por empleado y consulta de saldos pagados. Los pagos se registran en Finanzas → Pagos.',
  sidebarItems: [LAB_SAL_SALARIES_ITEM, LAB_SAL_PERIODS_ITEM, LAB_SAL_PAYMENTS_ITEM],
}
